// Sdílený info panel pro sidebar StationGroupLayout — shrnutí Skupina/Filtry/Produkt (viz doc/plans/station-group-layout.md sekce II)
// label je volitelný — když je vykreslený nad ním PanelHeader se stejným labelem (viz
// doc/plans/station-group-sidebar-redesign.md), předává se label={null} a InfoPanel ukazuje jen summary.
export function InfoPanel({ label, summary, preset, onClick, trailing }) {
  const Tag = onClick ? 'button' : 'div'
  return (
    <div className={`w-full flex items-center gap-1 border-b border-gray-100 text-xs ${onClick ? 'hover:bg-gray-50' : ''}`}>
      <Tag
        onClick={onClick}
        className={`flex-1 min-w-0 text-left px-3 py-2 ${onClick ? 'cursor-pointer' : ''}`}
      >
        {label && <div className="font-semibold text-gray-500 uppercase tracking-wide mb-0.5">{label}</div>}
        {preset && <div className="text-gray-700 font-medium">{preset}</div>}
        <div className="text-gray-700">{summary}</div>
      </Tag>
      {trailing && <div className="pr-2 shrink-0">{trailing}</div>}
    </div>
  )
}
